import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _549328de = () => interopDefault(import('../../pages/digitalinvites.vue' /* webpackChunkName: "pages/digitalinvites" */))
const _78f4bea4 = () => interopDefault(import('../../pages/editor/appystudio/index.vue' /* webpackChunkName: "pages/editor/appystudio/index" */))
const _00799059 = () => interopDefault(import('../../pages/editor/email.vue' /* webpackChunkName: "pages/editor/email" */))
const _699a0494 = () => interopDefault(import('../../pages/editor/no-mobile-access.vue' /* webpackChunkName: "pages/editor/no-mobile-access" */))
const _2da68f90 = () => interopDefault(import('../../pages/editor/noaccess.vue' /* webpackChunkName: "pages/editor/noaccess" */))
const _68ff1bca = () => interopDefault(import('../../pages/editor/appystudio/emailpreview.vue' /* webpackChunkName: "pages/editor/appystudio/emailpreview" */))
const _05317a98 = () => interopDefault(import('../../pages/editor/appystudio/welcome.vue' /* webpackChunkName: "pages/editor/appystudio/welcome" */))
const _95c81b92 = () => interopDefault(import('../../pages/editor/appystudio/welcome/index.vue' /* webpackChunkName: "pages/editor/appystudio/welcome/index" */))
const _61c63367 = () => interopDefault(import('../../pages/editor/appystudio/welcome/select.vue' /* webpackChunkName: "pages/editor/appystudio/welcome/select" */))
const _0592df8e = () => interopDefault(import('../../pages/editor/appystudio/load/_template.vue' /* webpackChunkName: "pages/editor/appystudio/load/_template" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/digitalinvites",
      component: _549328de,
      name: "digitalinvites"
    }, {
      path: "/editor/appystudio",
      component: _78f4bea4,
      name: "editor-appystudio"
    }, {
      path: "/editor/email",
      component: _00799059,
      name: "editor-email"
    }, {
      path: "/editor/no-mobile-access",
      component: _699a0494,
      name: "editor-no-mobile-access"
    }, {
      path: "/editor/noaccess",
      component: _2da68f90,
      name: "editor-noaccess"
    }, {
      path: "/editor/appystudio/emailpreview",
      component: _68ff1bca,
      name: "editor-appystudio-emailpreview"
    }, {
      path: "/editor/appystudio/welcome",
      component: _05317a98,
      children: [{
        path: "",
        component: _95c81b92,
        name: "editor-appystudio-welcome"
      }, {
        path: "select",
        component: _61c63367,
        name: "editor-appystudio-welcome-select"
      }]
    }, {
      path: "/editor/appystudio/load/:template?",
      component: _0592df8e,
      name: "editor-appystudio-load-template"
    }],

    fallback: false
  })
}
